// InvoiceNumberSetting Component to set InitialInvoiceNumber (only when it is the first invoice for the client)

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DateUtil from '../../../lib/dateutil.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Input from '../input/input.jsx'

class InvoiceNumberSetting extends Component {
  constructor (props) {
    super(props)
    this.state = { initialInvoiceNumber: '' }
  }

  static get propTypes () {
    return {
      onChange: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onChange: null
    }
  }

  _onChangeInput (name, value) {
    this.props.onChange(name, value)
    this.setState({ [name]: value })
  }

  render () {
    return (
      <div className='form-prompt'>
        <p className='form-message'>
          <span className='icon-purchaseorder-info' />
          <IntlMessage ident='invoice.form.chooseMessage' />
          <span className='form-message_attention'>
            <b>
              {' '}
              <IntlMessage ident='invoice.form.firstInvoiceNumber' />
            </b>
            .{' '}
          </span>
          <IntlMessage ident='invoice.form.warningMessage' />
        </p>
        <div className='form-flex'>
          <Input
            size={6}
            value={'  ' + DateUtil.getDisplayYear(new Date()) + '  '}
            multilingual='false'
            disabled
          />
          <Input
            name='initialInvoiceNumber'
            type='number'
            label='invoice.form.labelInvoiceNumber'
            placeholder='true'
            value={this.state.initialInvoiceNumber}
            onChange={this._onChangeInput.bind(this, 'initialInvoiceNumber')}
            validations={['required', 'positive']}
          />
        </div>
      </div>
    )
  }
}

export default InvoiceNumberSetting
